<template>
  <section class="w-full">
    <!-- Hero image -->
    <div class="w-full h-[60vh] sm:h-[70vh] overflow-hidden">
      <img
        src="/images/cover.jpg"
        alt="Måndagsklubben"
        class="w-full h-full object-cover"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: "BannerSection",
};
</script>
